import { render, staticRenderFns } from "./machineDate.vue?vue&type=template&id=38cb3cb8&scoped=true&"
import script from "./machineDate.vue?vue&type=script&lang=js&"
export * from "./machineDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb3cb8",
  null
  
)

export default component.exports